module.exports = require('../../es/array/from');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/features/array/from.js
// module id = 181
// module chunks = 0